import { useRef, useEffect } from "react";
import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isBrowser } from "^/utils/isBrowser";
import FormFieldWrapper from "../FormFieldWrapper";
import CheckboxOptionWidgetComponent from "../CheckboxOptionWidget/CheckboxOptionWidgetComponent";
import ErrorBlock from "../ErrorBlock";
import { getValidationResult } from "../../formHelpers";

function CheckboxWidgetComponent({ widget, inputsWithErrors, processAnswer }) {
  const checkedItemsRef = useRef([]);

  useEffect(() => {
    const myStorage = isBrowser ? window.sessionStorage : {};
    const stored = JSON.parse(myStorage.getItem(widget.id()));
    if (stored) checkedItemsRef.current = stored;
  }, [widget]);

  const setSessionStorage = (items) => {
    const myStorage = isBrowser ? window.sessionStorage : {};
    myStorage.setItem(widget.id(), JSON.stringify(items));
  };

  const handleCheckboxes = (value) => {
    const prev = checkedItemsRef.current;
    const next =
      prev.indexOf(value) === -1
        ? [...prev, value]
        : prev.filter((n) => n !== value);
    checkedItemsRef.current = next;
    setSessionStorage(next);
  };

  const handleInputChange = (ev) => {
    processAnswer({ widget, value: ev.target.value });
  };

  const validation = getValidationResult(inputsWithErrors, widget.id());

  return (
    <>
      <div
        className={classNames("form-group form-field", {
          invalid: !!validation,
        })}
      >
        <FormFieldWrapper
          className="checkbox-group p-0"
          widget={widget}
          inputsWithErrors={inputsWithErrors}
          checkbox
        >
          {widget.get("checkboxOptions").map((option) => (
            <CheckboxOptionWidgetComponent
              key={option.id()}
              widget={option}
              handleCheckboxes={handleCheckboxes}
              handleInputChange={handleInputChange}
            />
          ))}
        </FormFieldWrapper>
        <ErrorBlock validation={validation} lang={widget.obj().language()} />
      </div>
    </>
  );
}

Scrivito.provideComponent("CheckboxWidget", CheckboxWidgetComponent);
